import { createSelector, MemoizedSelector } from '@ngrx/store';
import { SearchState, StateWithSearch } from '../search-state';
import { getCustomSearchState } from './feature.selector';

type SelectedFacetsState = SearchState['selectedFacets'];

export const getSelectedFacetsState: MemoizedSelector<StateWithSearch, SelectedFacetsState> = createSelector(
  getCustomSearchState,
  (state: SearchState) => {
    return state.selectedFacets || [];
  },
);
